import { Icon } from '@livable/saas-react-components';
import React from 'react';
import { formatUtilityLabel, getUtilityIconType } from 'src/pages/NewBillingModule/ApplyBillingFull/BillAutomationExtraction';
import useStyles from './billDetailsStyles';

/**
 * Vertical utility switcher on the left of a line items / allocation table body.
 * `isApproved` drives the status dot, which only the allocation tables show.
 */
export function UtilityRail(_ref) {
  let activeIndex = _ref.activeIndex,
    onAdd = _ref.onAdd,
    onChange = _ref.onChange,
    _ref$showStatus = _ref.showStatus,
    showStatus = _ref$showStatus === void 0 ? false : _ref$showStatus,
    utilities = _ref.utilities;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": "Utilities on this bill",
    className: classes.utilityRail,
    role: "tablist"
  }, utilities.map((utility, index) => {
    const isActive = index === activeIndex;
    const label = formatUtilityLabel(utility.serviceType);
    return /*#__PURE__*/React.createElement("button", {
      "aria-label": label,
      "aria-selected": isActive,
      className: "".concat(classes.utilityRailItem, " ").concat(isActive ? classes.utilityRailItemActive : ''),
      key: "".concat(utility.serviceType, "-").concat(index),
      onClick: () => onChange(index),
      role: "tab",
      title: label,
      type: "button"
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.utilityRailIconBox, " ").concat(utility.isApproved ? classes.utilityRailIconBoxDone : '')
    }, /*#__PURE__*/React.createElement(Icon, {
      state: isActive ? 'dark' : 'grey',
      type: getUtilityIconType(utility.serviceType)
    })), showStatus ? /*#__PURE__*/React.createElement("span", {
      className: classes.utilityRailStatus
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.utilityRailStatusDot, " ").concat(utility.isApproved ? classes.utilityRailStatusDotDone : '')
    })) : null);
  }), onAdd ? /*#__PURE__*/React.createElement("button", {
    "aria-label": "Add a utility",
    className: classes.railAddButton,
    onClick: onAdd,
    title: "Add a utility",
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "grey",
    type: "plus"
  })) : null);
}